// https://vuex.vuejs.org/en/mutations.html

export default {
  set_rows(state, rows) {
    state.rows = rows;
  },
};
